import { LinkText } from 'components';
import { Link } from 'react-router-dom';
import translate from 'translate';
import styles from './styles.module.scss';

export default () => (
  <div className={styles.getPracticalInfoLinks}>
    <LinkText as={Link} to={'/learn/articleContainer/46H4g90wBOU05cLeFblYz5'}>
      {translate('Learn_Practical_Info_Read_More_Expedition')}
    </LinkText>
    <LinkText as={Link} to={'/learn/articleContainer/2Zo7phzmbl8cPZ80f1BMUb'}>
      {translate('Learn_Practical_Info_Read_More_Coastal')}
    </LinkText>
  </div>
);
